import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchBalance } from 'shared/actions/user';
import { getDisplayName } from 'shared/helpers/common';

const withBalance = forceUpdate => WrappedComponent => {
  const Component = class extends React.Component {
    static displayName = `withBalance(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      fetchBalance: PropTypes.func.isRequired,
      isFetching: PropTypes.bool.isRequired,
      balance: PropTypes.number,
    };
    static defaultProps = {
      balance: null,
    };

    componentDidMount() {
      if (forceUpdate || this.props.balance === null) {
        this.props.fetchBalance();
      }
    }

    render() {
      const { fetchBalance: __, ...props } = this.props;

      return <WrappedComponent {...props} />;
    }
  };

  const mapStateToProps = ({ user }) => ({
    balance: user.balance.amount,
    isFetching: user.balance.isFetching,
  });
  const mapDispatchToProps = {
    fetchBalance,
  };

  return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export default withBalance;



// WEBPACK FOOTER //
// ./src/shared/hocs/withBalance.js